// Helpers compartidos de los indicadores de Customer Success (% Activación y % Uso), usados por
// la lista «Customer Success» y el «Reporte por empresa» para que se lean igual en ambas vistas.

// Semáforo de los porcentajes: verde desde 70%, naranjo desde 40%, rojo bajo eso.
export function scoreColor(pct) {
  if (pct >= 70) return 'green';
  if (pct >= 40) return 'orange';
  return 'red';
}

// Base del % de activación según la línea de negocio que devolvió el backend.
export function activationBasisLabel(basis) {
  return basis === 'quota' ? 'Cuota contratada' : 'Cuentas totales';
}
